import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { GlobalService } from "../../services/global.service";
import * as use from '@tensorflow-models/universal-sentence-encoder';
var DevtPlaygroundComponent = /** @class */ (function () {
    function DevtPlaygroundComponent(service) {
        this.service = service;
        this.list_sentences = [];
        this.plotly_heatmap = { data: [], layout: {} };
    }
    DevtPlaygroundComponent.prototype.ngOnInit = function () {
        this.service.changePageTitle('Development Playground');
        this.main();
    };
    DevtPlaygroundComponent.prototype.get_embeddings = function (list_sentences, callback) {
        use.load().then(function (model) {
            model.embed(list_sentences).then(function (embeddings) {
                callback(embeddings);
            });
        });
    };
    DevtPlaygroundComponent.prototype.dot = function (a, b) {
        var hasOwnProperty = Object.prototype.hasOwnProperty;
        var sum = 0;
        for (var key in a) {
            if (hasOwnProperty.call(a, key) && hasOwnProperty.call(b, key)) {
                sum += a[key] * b[key];
            }
        }
        return sum;
    };
    DevtPlaygroundComponent.prototype.similarity = function (a, b) {
        var magA = Math.sqrt(this.dot(a, a));
        var magB = Math.sqrt(this.dot(b, b));
        if (magA && magB)
            return this.dot(a, b) / (magA * magB);
        else
            return false;
    };
    DevtPlaygroundComponent.prototype.cosine_similarity_matrix = function (matrix) {
        var cosine_similarity_matrix = [];
        for (var i = 0; i < matrix.length; i++) {
            var row = [];
            for (var j = 0; j < i; j++) {
                row.push(cosine_similarity_matrix[j][i]);
            }
            row.push(1);
            for (var j = (i + 1); j < matrix.length; j++) {
                row.push(this.similarity(matrix[i], matrix[j]));
            }
            cosine_similarity_matrix.push(row);
        }
        return cosine_similarity_matrix;
    };
    DevtPlaygroundComponent.prototype.main = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var list_sentences, callback, embeddings;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        list_sentences = [
                            // Smartphones
                            "I like my phone",
                            "My phone is not good.",
                            "Your cellphone looks great.",
                            // Weather
                            "Will it snow tomorrow?",
                            "Recently a lot of hurricanes have hit the US",
                            "Global warming is real",
                            // Food and health
                            "An apple a day, keeps the doctors away",
                            "Eating strawberries is healthy",
                            "Is paleo better than keto?",
                            // Asking about age
                            "How old are you?",
                            "what is your age?"
                        ];
                        callback = function (embeddings) {
                            console.log("embeddings", embeddings);
                            var cosine_similarity_matrix = this.cosine_similarity_matrix(embeddings.arraySync());
                            var colors = [];
                            var base_color = 54;
                            for (var i = 0; i <= 10; i++) {
                                colors.push([i / 10, "rgb(" + (base_color + (i * 20)) + ", 0, 0)"]);
                            }
                            console.log(cosine_similarity_matrix);
                            this.plotly_heatmap = {
                                data: [
                                    {
                                        z: cosine_similarity_matrix,
                                        x: list_sentences,
                                        y: list_sentences,
                                        type: 'heatmap',
                                        colorscale: colors
                                    }
                                ],
                                layout: { height: 1200, title: "Similarity", autosize: true }
                            };
                        };
                        return [4 /*yield*/, this.get_embeddings(list_sentences, callback.bind(this))];
                    case 1:
                        embeddings = _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return DevtPlaygroundComponent;
}());
export { DevtPlaygroundComponent };
